import { useGetSurveyById } from "@/features/survey/hooks/useQuery/useGetSurveyById";
import { useSurveyStore } from "@/lib/zustand/useStore";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";

export default function SurveyProvider() {
    const { surveyId } = useParams()
    const { setSurvey } = useSurveyStore();
    const { data: survey } = useGetSurveyById(surveyId!)
    useEffect(() => {
        if(survey){
            setSurvey(survey)
        }
    }, [surveyId, survey, setSurvey])
    return (
        <>
            <Outlet />
        </>
    )
}